import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import AvatarSrc from 'images/profile_pic.svg';
import useAutosize from 'hooks/useAutosize';
import EmailMessage from '../../EmailPractice/EmailMessage';
import ChatMessage from '../../ChatPractice/ChatMessage';
import TicketHandlingMessage from '../../TicketHandlingPractice/TicketHandlingMessage';

const ReplyContainer = ({
  previewing,
  questionType,
  placeholder,
  isDisabled,
  data,
  timeStamp,
  questionChatData,
  questionTicketHandlingData,
  updateMessage,
  givenAnswer,
  message,
  i18n,
}) => {
  const [updatedMessage, setUpdatedMessage] = useState('');
  const [updateTriggered, setUpdateTriggered] = useState(false);
  const isChatReplyQuestion = questionType === 'chat';
  const isEmailReplyQuestion = questionType === 'email_reply';
  const isTicketHandlingQuestion = questionType === 'ticket_handling';
  const autosizeRef = useAutosize();

  useEffect(() => {
    if (questionType === 'ticket_handling' && message && !previewing) {
      setUpdatedMessage(message);
    } else if (givenAnswer) {
      setUpdatedMessage(givenAnswer);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!previewing && updateTriggered) {
      updateMessage(updatedMessage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedMessage, updateTriggered]);

  const handleReply = e => {
    setUpdatedMessage(e.target.value);
    setUpdateTriggered(true);
  };

  const renderAvatar = styles => {
    const avatarStyles = classNames({ [styles]: styles });

    return (
      <div className={avatarStyles}>
        <img
          alt="Avatar"
          className="ReplyContainer-avatar"
          height="50"
          src={AvatarSrc}
        />
      </div>
    );
  };

  return (
    <div>
      {isChatReplyQuestion && (
        <ChatMessage
          questionChatData={questionChatData}
          i18n={i18n}
          renderAvatar={renderAvatar}
        />
      )}
      {isEmailReplyQuestion && (
        <EmailMessage
          data={data}
          timeStamp={timeStamp}
          renderAvatar={renderAvatar}
        />
      )}
      {isTicketHandlingQuestion && (
        <TicketHandlingMessage
          data={questionTicketHandlingData}
          i18n={i18n}
          renderAvatar={renderAvatar}
        />
      )}
      <textarea
        data-test-id="reply-container-textarea"
        className="ReplyContainer-input h-100 pl-12 mt-16 p-8 bdrs-2 w-fill bg-gray-lightest border border-gray-light"
        disabled={isDisabled}
        onChange={handleReply}
        placeholder={placeholder}
        value={previewing ? '' : updatedMessage}
        ref={autosizeRef}
      />
    </div>
  );
};

export default ReplyContainer;
